import { render, staticRenderFns } from "./AdminDesk.vue?vue&type=template&id=2cd503f0"
import script from "./AdminDesk.vue?vue&type=script&lang=js"
export * from "./AdminDesk.vue?vue&type=script&lang=js"
import style0 from "./AdminDesk.vue?vue&type=style&index=0&id=2cd503f0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports